import { PriceProviderType } from 'domain/types';

export const PRICE_PROVIDER_NAMES: Record<PriceProviderType, string> = {
  UniswapV3: 'Uniswap V3',
  BalancerV2: 'Balancer V2',
  ChainlinkV3: 'Chainlink V3',
  FixedPrice: 'Fixed',
  LpToken: 'Forwarded',
  Forwarded: 'Forwarded',
  CustomFeedOnchain: 'Onchain Feed',
  CustomFeedOffchain: 'Offchain Feed',
  UniswapV3Forwarded: 'Uniswap V3 Forwarded',
  Disabled: 'Disabled',
  Unknown: 'Unknown',
};
